module.exports = __webpack_public_path__ + "static/img/create-user.c6ec9f7e.png";